export { Search as default } from './Search';
